import { setApprovalProjectListSelected } from 'actions/approvalProjectActions.js';

import {
    ApprovalSidebarLink,
    TextLine,
    SentDate,
    Sender,
    createCheckboxCell
} from 'components/common/tableComponents/cellTemplates';
import { APPROVAL_PROJECT_SIDEBAR } from 'constants/sidebarTypes';

const ApprovalProjectTableTemplates = {
    checkbox:   createCheckboxCell('approvalProject', setApprovalProjectListSelected),
    general:    ApprovalSidebarLink(APPROVAL_PROJECT_SIDEBAR, 'typeName'),
    sender:     Sender,
    date:       SentDate,
};

export default function getApprovalProjectTableTemplate(columnName) {
    return ApprovalProjectTableTemplates[columnName] || TextLine;
}
